import globModules from './glob-modules';

const modules = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'CalloutMulti',
    loader: () => import('./modules/callout-multi')
  },
  {
    name: 'SimilarBoats',
    loader: () => import('./modules/similar-boats')
  },
  {
    name: 'MainSpecs',
    loader: () => import('./modules/main-specs')
  },
  {
    name: 'BasicInfo',
    loader: () => import('./modules/basic-info')
  },
  {
    name: 'MarinasServices',
    loader: () => import('./modules/marinas-services')
  },
  {
    name: 'CalloutBoatsFeatured',
    loader: () => import('./modules/callout-boats-featured')
  },
  {
    name: 'ModelsForBrand',
    loader: () => import('./modules/models-for-brand')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'CalloutBoatsFeatured',
    loader: () => import('./modules/callout-boats-featured')
  },
  {
    name: 'Testimonial',
    loader: () => import('./modules/testimonial')
  },
  {
    name: 'ActivityLocation',
    loader: () => import('./modules/activity-location')
  },
  {
    name: 'ImageGallery',
    loader: () => import('./modules/image-gallery')
  },
  {
    name: 'EventType',
    loader: () => import('./modules/event-type-nav')
  },
  {
    name: 'HeroSearchBoat',
    loader: () => import('./modules/hero-search-boat')
  },
  {
    name: 'BrandSibling',
    loader: () => import('./modules/brand-sibling')
  },
  {
    name: 'StoreDetail',
    loader: () => import('./modules/store-detail')
  },
  {
    name: 'MultiFormContainer',
    loader: () => import('./modules/multi-form-container')
  },
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  }
];

export default [...globModules, ...modules];
